<script setup lang="ts">
import RouterViewTransition from '@/components/RouterViewTransition.vue'
import LoadingPage from './components/loading/LoadingPage.vue'
import Toasts from './components/Toasts.vue'
import RateLimitingModal from './components/modals/RateLimitingModal.vue'
import PremiumMembershipModal from './components/modals/PremiumMembershipModal.vue'
</script>

<template>
  <RouterViewTransition v-if="$auth.loaded" is-root></RouterViewTransition>
  <LoadingPage v-else></LoadingPage>
  <Toasts />
  <RateLimitingModal />
  <PremiumMembershipModal />
</template>
